<div class="flex-col height100p">
    <sm-toolbar class="flex-item-fixed">
        <p-button icon="fas fa-run" label="Holen" (onClick)="getLicenses()"></p-button>
    </sm-toolbar>
    <p-tabView *ngIf="lic != null" class="flex-item-fill direct-sub">
        <p-tabPanel header="Lizenzverwaltung">
            <sm-table2 #table *ngIf="tableData != null" class="height100p" [data]="tableData"></sm-table2>
        </p-tabPanel>
        <p-tabPanel header="Lizenzdatei">
            <textarea *ngIf="app.advancedDeveloper" pInputTextarea spellcheck=false class="width100p height100p monospace no-resize" [ngModel]="lic.raw"></textarea>
        </p-tabPanel>
    </p-tabView>
</div>
